import { gql } from '@apollo/client';

export const UPDATE_FANTASY_LEAGUE = gql`
  mutation UpdateFantasyLeague($input: UpdateFantasyLeagueInput!) {
    updateFantasyLeague(input: $input) {
      errors
      fantasyLeague {
        id
        name
        isPublic
        maxPlayers
      }
    }
  }
`;